module.exports = __webpack_public_path__ + "static/media/1.5b27e86d.jpg";